import { commonReducer } from "common/store";
import { developerReducer } from "developer/store";
import { combineReducers } from "redux";
import attachmentsReducer from "store/attachments/attachmentsSlice";
import formDataReducer from "store/form/formDataSlice";
import resourcesStoreReducer from "store/resourcesStore/resourcesStoreSlice";

const rootReducer = combineReducers({
  attachments: attachmentsReducer,
  formData: formDataReducer,
  resourcesStore: resourcesStoreReducer,
  developer: developerReducer,
  common: commonReducer,
});

export default rootReducer;
